"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DurationInfo;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _Separator = _interopRequireDefault(require("../components/Separator"));

var _DarkText = _interopRequireDefault(require("../../DarkText"));

var s = {
  durationInfo:
  /*#__PURE__*/
  (0, _emotion.css)("overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;margin-right:-1px;")
};

var getDuration = function getDuration(time) {
  if (typeof time === 'number') {
    var secs = Math.round(time);
    var hours = Math.floor(secs / (60 * 60));
    var divisorForMinutes = secs % (60 * 60);
    var minutes = Math.floor(divisorForMinutes / 60);
    var divisorForSeconds = divisorForMinutes % 60;
    var seconds = Math.ceil(divisorForSeconds);
    var formattedTime = '';

    if (hours) {
      formattedTime += "".concat(hours, " ").concat(hours > 1 ? 'hours ' : 'hour ');
    }

    if (minutes) {
      formattedTime += "".concat(minutes, " ").concat(minutes > 1 ? 'minutes ' : 'minute ');
    }

    if (formattedTime.indexOf('hour') === -1) {
      if (seconds) {
        formattedTime += "".concat(seconds, " ").concat(seconds > 1 ? 'seconds ' : 'second ');
      }
    }

    return formattedTime;
  }

  return "".concat(time);
};

function DurationInfo(props) {
  var duration = props.duration,
      noSeparator = props.noSeparator,
      fontSize = props.fontSize;

  if (!duration) {
    return null;
  }

  return _react.default.createElement(_react.default.Fragment, null, !noSeparator && _react.default.createElement(_Separator.default, null), _react.default.createElement(_DarkText.default, {
    color: "iron",
    fontSize: fontSize || 14,
    fontSizeS: 10,
    className: s.durationInfo,
    letterSpacing: "normal"
  }, getDuration(duration)));
}